document.addEventListener("DOMContentLoaded", function () {
  // Tooltip implementation in mobile view
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const tooltipWords = document.querySelectorAll(".cb-tooltip-word");

  const globalOverlay = document.getElementById(
    "global-mobile-tooltip-overlay"
  );
  const globalTooltip = document.getElementById(
    "global-mobile-tooltip-container"
  );
  const globalTooltipWord = document.getElementById(
    "global-mobile-tooltip-word"
  );
  const globalTooltipText = document.getElementById(
    "global-mobile-tooltip-text"
  );
  const globalCloseBtn = document.getElementById("global-mobile-tooltip-close");

  function showMobileTooltip(word, content) {
    document.body.classList.add("no-scroll-while-popup");
    globalOverlay.classList.add("active");
    globalTooltip.classList.add("active");
    globalTooltipWord.textContent = word;
    globalTooltipText.innerHTML = content;
  }

  function hideMobileTooltip() {
    document.body.classList.remove("no-scroll-while-popup");
    globalOverlay.classList.remove("active");
    globalTooltip.classList.remove("active");
    globalTooltipWord.textContent = "";
    globalTooltipText.innerHTML = "";
  }

  tooltipWords.forEach((wordElement) => {
    const tooltipContent = wordElement.getAttribute("data-cb-tooltip");
    const clickedWord = wordElement.textContent;
    if (isMobile) {
      wordElement.addEventListener("click", function () {
        const tooltipContent = wordElement.getAttribute("data-cb-tooltip");
        const clickedWord = wordElement.textContent;
        showMobileTooltip(clickedWord, tooltipContent);
      });
    }
  });

  globalCloseBtn.addEventListener("click", hideMobileTooltip);
  globalOverlay.addEventListener("click", hideMobileTooltip);

  if (!isMobile) {
    const globalTooltip = document.createElement("div");
    globalTooltip.classList.add("cb-tooltip-desktop");
    globalTooltip.innerHTML = `
    <div class="cb-tooltip-title"></div>
    <div class="cb-tooltip-text"></div>
  `;
    document.body.appendChild(globalTooltip);
    // Event delegation for hover tooltips
    document.addEventListener("mouseover", function (event) {
      const target = event.target.closest(".cb-tooltip-word");
      if (!target) return;

      const tooltipContent = target.getAttribute("data-cb-tooltip");
      const tooltipWord = target.getAttribute("data-cb-word");
      const tooltipTitle = globalTooltip.querySelector(".cb-tooltip-title");
      const tooltipText = globalTooltip.querySelector(".cb-tooltip-text");

      tooltipTitle.textContent = tooltipWord || "Tooltip";
      tooltipText.textContent = tooltipContent;

      globalTooltip.style.display = "block";

      const rect = target.getBoundingClientRect();
      const tooltipWidth = globalTooltip.offsetWidth;
      const tooltipHeight = globalTooltip.offsetHeight;

      let top = rect.bottom + window.scrollY + 8; // Add spacing
      let left = rect.left + rect.width / 2 - tooltipWidth / 2;

      // Prevent overflow
      if (left < 0) left = 10; // Avoid left overflow
      if (left + tooltipWidth > window.innerWidth)
        left = window.innerWidth - tooltipWidth - 10; // Avoid right overflow
      if (top + tooltipHeight > window.innerHeight)
        top = rect.top + window.scrollY - tooltipHeight - 8; // Move above if necessary

      globalTooltip.style.top = `${top}px`;
      globalTooltip.style.left = `${left}px`;
    });

    document.addEventListener("mouseout", function (event) {
      const target = event.target.closest(".cb-tooltip-word");
      if (!target) return;

      // Hide tooltip
      globalTooltip.style.display = "none";
    });
  }
});